import styled from 'styled-components';

export const Wrapper = styled.div<{
  $isSelected: boolean;
  $isEmpty: boolean;
}>`
  display: flex;
  padding: 12px;
  width: 100%;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $isSelected, $isEmpty }) =>
      $isEmpty
        ? $isSelected
          ? theme.colors.orange6
          : theme.colors.orange4
        : $isSelected
        ? theme.colors.green6
        : theme.colors.green4};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  min-height: 70px;
  transition: all 0.2s ease-in-out;
  box-shadow: ${({ theme, $isSelected, $isEmpty }) =>
    $isSelected
      ? $isEmpty
        ? `0px 0px 1px 2px ${theme.colors.orange2}`
        : `0px 0px 1px 2px ${theme.colors.green2}`
      : 'none'};
`;

export const TextWrapper = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black6};
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
